export interface Product {
  id: string
  slug: string
  title: string
  description: string
  longDescription: string
  image: string
  category: string
  keywords: string
  priceRange?: string
  price?: string
  rating?: number
  reviewCount?: number
  features: string[]
  specifications?: {
    material?: string
    sizes?: string[]
    thickness?: string
    durability?: string
  }
}

export const products: Product[] = [
  {
    id: 'marshall-scribe-custom-logo-mat',
    slug: 'marshall-scribe-custom-logo-mat',
    title: 'Marshall Scribe Custom Logo Mat',
    description: 'Premium Marshall Scribe custom logo door mat with high-definition branding. Perfect for entrances, offices, and commercial spaces in Zambia.',
    longDescription: 'The Marshall Scribe Custom Logo Mat is a premium quality door mat featuring superior print quality and durability. Engineered for high-traffic areas, this mat provides excellent logo visibility while protecting your flooring investment. Ideal for corporate offices, retail stores, and commercial entrances across Zambia.',
    image: '/images/homematsproductcards/MARSHALL SCRIBE CUSTOM LO.webp',
    category: 'Premium Mats',
    keywords: 'Marshall Scribe mat, custom logo mat, branded door mat Zambia, premium door mat, corporate mat, office entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 72,
    features: [
      'High-definition logo printing',
      'Durable construction',
      'Suitable for high-traffic areas',
      'Custom branding available',
      'Fast delivery across Zambia'
    ],
    specifications: {
      material: 'Premium synthetic fibers',
      sizes: ['Custom sizes available'],
      durability: 'Heavy-duty'
    }
  },
  {
    id: 'novamat-custom-logo-mat',
    slug: 'novamat-custom-logo-mat',
    title: 'Novamat Custom Logo Mat',
    description: 'Novamat custom logo door mat with excellent durability and vibrant logo printing. Perfect for businesses and homes in Zambia.',
    longDescription: 'The Novamat Custom Logo Mat combines style and functionality with its superior construction and high-quality logo printing. This mat is designed to withstand daily wear while maintaining your brand visibility. Available in various sizes and custom branding options.',
    image: '/images/homematsproductcards/NOVAMAT CUSTOM LOGO MAT.webp',
    category: 'Standard Mats',
    keywords: 'Novamat door mat, custom logo mat Zambia, branded mat, business mat, entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 65,
    features: [
      'Vibrant logo printing',
      'Weather resistant',
      'Easy to clean',
      'Custom sizes available',
      'Multiple color options'
    ],
    specifications: {
      material: 'Quality synthetic materials',
      sizes: ['Standard and custom sizes'],
      durability: 'Standard to heavy-duty'
    }
  },
  {
    id: 'novamat-custom-logo-mat-2',
    slug: 'novamat-custom-logo-mat-2',
    title: 'Novamat Custom Logo Mat 2',
    description: 'Second generation Novamat custom logo door mat with enhanced features and improved durability. Ideal for commercial and residential use in Zambia.',
    longDescription: 'The Novamat Custom Logo Mat 2 is an upgraded version featuring enhanced durability and improved logo clarity. This mat is perfect for businesses looking for a reliable, long-lasting entrance solution with professional branding.',
    image: '/images/homematsproductcards/NOVAMAT CUSTOM LOGO MAT2.webp',
    category: 'Standard Mats',
    keywords: 'Novamat mat 2, custom logo mat, branded door mat, commercial mat Zambia, entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 38,
    features: [
      'Enhanced durability',
      'Improved logo clarity',
      'Weather resistant',
      'Commercial grade',
      'Custom branding'
    ],
    specifications: {
      material: 'Enhanced synthetic materials',
      sizes: ['Custom sizes available'],
      durability: 'Heavy-duty'
    }
  },
  {
    id: 'super-deco-custom-logo',
    slug: 'super-deco-custom-logo',
    title: 'Super Deco Custom Logo',
    description: 'Super Deco custom logo door mat with stylish design and premium quality. Perfect for modern entrances and commercial spaces in Zambia.',
    longDescription: 'The Super Deco Custom Logo mat features a modern, stylish design combined with premium quality materials. This mat offers excellent logo visibility and durability, making it perfect for contemporary offices, retail spaces, and modern homes.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO.webp',
    category: 'Designer Mats',
    keywords: 'Super Deco mat, custom logo mat, designer door mat, modern mat Zambia, stylish entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 54,
    features: [
      'Modern design',
      'Premium materials',
      'Excellent logo visibility',
      'Contemporary styling',
      'Custom sizes available'
    ],
    specifications: {
      material: 'Premium synthetic',
      sizes: ['Standard and custom'],
      durability: 'Standard to premium'
    }
  },
  {
    id: 'super-deco-custom-logo-mat',
    slug: 'super-deco-custom-logo-mat',
    title: 'Super Deco Custom Logo Mat',
    description: 'Premium Super Deco custom logo door mat with superior quality and design. Ideal for high-end commercial and residential entrances in Zambia.',
    longDescription: 'The Super Deco Custom Logo Mat represents the pinnacle of door mat design and quality. With superior materials and exceptional logo printing, this mat is perfect for luxury offices, upscale retail locations, and premium residential entrances.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO MAT.webp',
    category: 'Premium Mats',
    keywords: 'Super Deco premium mat, luxury door mat, custom logo mat Zambia, high-end mat, premium entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 48,
    features: [
      'Premium quality',
      'Superior logo printing',
      'Luxury design',
      'High-end materials',
      'Custom branding'
    ],
    specifications: {
      material: 'Premium synthetic fibers',
      sizes: ['Custom sizes available'],
      durability: 'Premium heavy-duty'
    }
  },
  {
    id: 'super-deco-custom-logo-2',
    slug: 'super-deco-custom-logo-2',
    title: 'Super Deco Custom Logo 2',
    description: 'Super Deco Custom Logo 2 door mat with enhanced features and modern design. Perfect for contemporary spaces in Zambia.',
    longDescription: 'The Super Deco Custom Logo 2 offers an enhanced version of our popular Super Deco line. With improved durability and modern design elements, this mat is perfect for businesses and homes seeking a contemporary entrance solution.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO (2).webp',
    category: 'Designer Mats',
    keywords: 'Super Deco mat 2, custom logo mat, modern door mat Zambia, contemporary mat, designer entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 28,
    features: [
      'Enhanced features',
      'Modern design',
      'Improved durability',
      'Contemporary styling',
      'Custom options available'
    ],
    specifications: {
      material: 'Quality synthetic',
      sizes: ['Standard and custom'],
      durability: 'Standard to heavy-duty'
    }
  },
  {
    id: 'super-deco-custom-logo-3',
    slug: 'super-deco-custom-logo-3',
    title: 'Super Deco Custom Logo 3',
    description: 'Super Deco Custom Logo 3 door mat with unique design and premium quality. Ideal for distinctive entrances in Zambia.',
    longDescription: 'The Super Deco Custom Logo 3 features a unique design that stands out while maintaining premium quality standards. This mat is perfect for businesses and homes looking for a distinctive entrance solution with professional branding.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO (3).webp',
    category: 'Designer Mats',
    keywords: 'Super Deco mat 3, unique door mat, custom logo mat Zambia, distinctive mat, branded entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 33,
    features: [
      'Unique design',
      'Premium quality',
      'Distinctive styling',
      'Professional branding',
      'Custom sizes available'
    ],
    specifications: {
      material: 'Premium materials',
      sizes: ['Custom sizes available'],
      durability: 'Heavy-duty'
    }
  },
  {
    id: 'super-deco-custom-logo-4',
    slug: 'super-deco-custom-logo-4',
    title: 'Super Deco Custom Logo 4',
    description: 'Super Deco Custom Logo 4 door mat with advanced features and superior durability. Perfect for high-traffic areas in Zambia.',
    longDescription: 'The Super Deco Custom Logo 4 is designed for high-traffic areas with advanced features and superior durability. This mat combines excellent logo visibility with exceptional wear resistance, making it ideal for busy commercial entrances.',
    image: '/images/homematsproductcards/SUPER DECO CUSTOM LOGO (4).webp',
    category: 'Premium Mats',
    keywords: 'Super Deco mat 4, high-traffic door mat, custom logo mat Zambia, commercial mat, durable entrance mat',
    priceRange: 'Contact for pricing',
    price: 'K2700',
    rating: 5,
    reviewCount: 41,
    features: [
      'Advanced features',
      'Superior durability',
      'High-traffic design',
      'Excellent wear resistance',
      'Commercial grade'
    ],
    specifications: {
      material: 'Heavy-duty synthetic',
      sizes: ['Custom sizes available'],
      durability: 'Commercial heavy-duty'
    }
  },
]

export const getProductBySlug = (slug: string): Product | undefined => {
  return products.find(product => product.slug === slug)
}

export const getAllProducts = (): Product[] => {
  return products
}

